"use client";

import Link from "next/link";
import { useCreditsContext } from "@/contexts/CreditsContext";
import { storePurchaseContext } from "@/libs/ga";
import { trackFunnel } from "@/libs/analytics";

// Component to display user's current credit balance
const CreditsDisplay = () => {
  const { credits, isLoading } = useCreditsContext();

  const handleCreditsClick = () => {
    // Store voluntary purchase context with source
    storePurchaseContext({
      price_id: '', // Will be set when user selects package
      mode: 'payment',
      purchase_trigger: 'voluntary',
      source: 'credits_button',
      current_credits: credits || 0
    });

    // Track when user clicks credits to view pricing/purchase options
    trackFunnel('monetization', 'pricing_viewed', {
      source: 'credits_button',
      current_credits: credits,
      purchase_trigger: 'voluntary'
    });
  };

  return (
    <Link
      href="/dashboard/pricing"
      className="flex items-center gap-2 px-3 py-2 rounded-lg hover:!bg-gray-100 transition-colors cursor-pointer group"
      onClick={handleCreditsClick}
    >
      <span className="text-sm font-medium text-gray-600 group-hover:text-gray-800 transition-colors">Credits:</span>
      <div className="flex items-center gap-1.5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-4 h-4 text-primary group-hover:opacity-80 transition-opacity"
        >
          <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clipRule="evenodd" />
        </svg>
        {isLoading ? (
          <span className="loading loading-spinner loading-xs"></span>
        ) : (
          <span className="text-md font-bold text-gray-800 group-hover:text-primary transition-colors">{credits !== null ? credits : "-"}</span>
        )}
      </div>
    </Link>
  );
};

export default CreditsDisplay;
